import React from "react";
import { v4 as uuid } from "uuid";

import usePromotedEventLogger from "./usePromotedEventLogger";

export enum LogSearchActionTypes {
  NAVIGATE = "NAVIGATE",
  CHECKOUT = "CHECKOUT",
  LIKE = "LIKE",
  UNLIKE = "UNLIKE",
  PURCHASE = "PURCHASE",
}

interface AdditionalProps {
  timing?: { clientLogTimestamp: number };
  insertionId?: string;
  impressionId?: string;
  properties?: { [customProp: string]: any };
}

export type SearchImpressionsLogAction = (
  activityUid: string,
  actionType: LogSearchActionTypes,
  additionalProps?: AdditionalProps
) => void;

export default function useLogSearchAction(
  properties: any = {}
): SearchImpressionsLogAction {
  const eventLogger = usePromotedEventLogger(properties);

  const logSearchAction: SearchImpressionsLogAction = React.useCallback(
    (
      activityUid: string,
      actionType: LogSearchActionTypes,
      additionalProps: AdditionalProps = {}
    ) => {
      eventLogger.logAction({
        contentId: activityUid,
        actionId: uuid(),
        actionType,
        ...additionalProps,
      });
    },
    [eventLogger]
  );
  return logSearchAction;
}
